<template>
  <div class="indicador-management mx-1" v-if="asyncDataStatus_ready">
    <v-card class="mb-1" tile>
      <v-card-title class="pa-5 pb-3">
        <p>Indicadores</p>
        <span class="grey--text font-weight-regular subtitle-2 pt-1"
          >{{ "\xa0 (" + indicadores.length }} total)
        </span>
        <v-spacer></v-spacer>
        <div>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
            class="search"
          ></v-text-field>
        </div>
      </v-card-title>
      <v-card-text class="px-5 my-n3">
        <IndicadorAdiciona
          v-if="isPermissao"
          titulo="Criar Indicador"
          :logicaIntervencao="logicaIntervencao"
        ></IndicadorAdiciona>
      </v-card-text>

      <v-card-text class="px-5">
        <v-data-table
          class="fonte-table"
          :headers="headers"
          :items="indicadores"
          :search="search"
          no-data-text="Não há indicadores disponíveis"
          no-results-text="Nenhum indicador encontrado"
          sort-by="ordem"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td>
                <router-link class="indicador-link primaryConst--text" :to="{ name: routeNameIndicador, params: { logicaIntervencaoId: item.logicaIntervencao.id, indicadorId: item.id }}">
                  <strong>{{ item.posicaoFormatada }} {{ item.titulo }}</strong>
                </router-link>
              </td>
              <td>
                <span>{{
                  item.responsavel
                    ? item.responsavel.nome
                    : "Aguardando definição"
                }}</span>
              </td>
              <td>
                <span>{{ item.tipologia }}</span>
              </td>
              <td>
                <v-chip class="ma-2 pa-4">{{ item.valorDeBase }}{{ item.tipologia === "PROGRESSIVA" ? "%" : "" }}</v-chip>
              </td>
              <td>
                <v-chip color="primary" class="ma-2 pa-4">{{ item.totalEsperado }}{{ item.tipologia === "PROGRESSIVA" ? "%" : "" }}</v-chip>
              </td>
              <td>
                <v-chip color="warning" class="ma-2 pa-4">{{ item.totalAtingido }}{{ item.tipologia === "PROGRESSIVA" ? "%" : "" }}</v-chip>
              </td>
              <td>
                <v-chip color="success" class="ma-2 pa-4">{{ item.porcentagemTotalAtingido.toFixed(2) }}%</v-chip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-col cols="12"></v-col>

    <v-container fluid class="indicador-edit" v-if="0">
      v-if="indicadores.length"
      <v-card tile>
        <v-card-title>
          <p>Selececione um indicador</p>
        </v-card-title>

        <v-card-text>
          <v-select
            v-model="indicadorSelecionado"
            label="Indicadores"
            :items="indicadores"
            item-text="titulo"
            item-value="id"
            outlined
            return-object
          >
            <template v-slot:selection='{ item }'>
              {{ item.posicaoFormatada }} {{ item.titulo }}
            </template>
            <template v-slot:item="{ item }">
              {{ item.posicaoFormatada }} {{ item.titulo }}
            </template>
          </v-select>
        </v-card-text>
      </v-card>

      <v-col cols="12"></v-col>

      <v-tabs color="primary">
        <v-tabs-slider></v-tabs-slider>

        <v-tab :href="`#tab-info`" class="mr-5">
          <v-icon class="mr-3">mdi-book-information-variant</v-icon>
          Informações
        </v-tab>
        <v-tab class="mr-5" :href="`#tab-fontes`">
          <v-icon class="mr-3">mdi-clipboard-file</v-icon>
          Fontes de Verificação
        </v-tab>

        <v-tab-item :value="'tab-info'">
          <v-card elevation="0" flat tile>
          <v-progress-linear color="teal darken-4" height="25" :value="indicadorSelecionado.porcentagemTotalAtingido" striped >
            <template v-slot:default="{ value }">
              <v-chip class="mr-1 font-weight-bold" color="teal darken-4" text-color="white" small> {{value}}% </v-chip>
            </template>
          </v-progress-linear>

            <v-card-title>
              <p>{{ indicadorSelecionado.posicaoFormatada }} {{ indicadorSelecionado.titulo }}</p> 
            </v-card-title>
            <v-divider></v-divider>
              <v-card-text>

                <v-row>
                  <v-col cols="12" class="mb-n4">
                    <span class="font-weight-bold text-uppercase">Descrição:</span>
                    <p class="font-weight-light title ">
                      {{ indicadorSelecionado.descricao }}
                    </p>
                  </v-col>

                  <v-col cols="12">
                    <span class="font-weight-bold text-uppercase">Responsável por Lançamento de Fontes: </span>
                    <span class="font-weight-light title">{{ indicadorSelecionado.responsavel ? indicadorSelecionado.responsavel.nome : '' }}</span>
                  </v-col>

                  <v-col cols="6">
                    <span class="font-weight-bold text-uppercase">Ações:</span>
                    <p class="font-weight-light title">
                      {{ indicadorSelecionado.acoes ? indicadorSelecionado.acoes : ''}}
                    </p>
                  </v-col>

                  <v-col cols="6">
                    <span class="font-weight-bold text-uppercase">Recursos:</span>
                    <p class="font-weight-light title ">
                      {{ indicadorSelecionado.recursos ? indicadorSelecionado.recursos : '' }}
                    </p>
                  </v-col>                  

                  <v-col cols="6">
                    <span class="font-weight-bold text-uppercase">Criticidade:</span>
                    <p class="font-weight-light title">
                      {{ indicadorSelecionado.criticidade ? indicadorSelecionado.criticidade : ''}}
                    </p>
                  </v-col>
                  <v-col cols="6">
                    <span class="font-weight-bold text-uppercase">Descrição das Fontes de Verificação:</span>
                    <p class="font-weight-light title ">
                      {{ indicadorSelecionado.descricaoFonteVerificaao ? indicadorSelecionado.descricaoFonteVerificaao : ''}}
                    </p>
                  </v-col>

                  <v-col cols="12" class="mt-n4">
                    <span class="font-weight-bold text-uppercase">Formulários: </span>
                    <p class="font-weight-light title" v-if="indicadorSelecionado.listaPresenca">Lista de Presença (Presencial/Virtual)</p>
                    <p class="font-weight-light title" v-if="indicadorSelecionado.relatoriaReuniaoEncontro">Relatoria de Reunião Encontro</p>
                    <p class="font-weight-light title" v-if="indicadorSelecionado.planoOficinaIntercambioCaravana">Plano de Oficina Intercâmbio Caravana</p>
                    <p class="font-weight-light title" v-if="indicadorSelecionado.relatoriaOficinaIntercambioCaravana">Relatoria de Oficina Intercâmbio Caravana</p>
                    <p class="font-weight-light title" v-if="indicadorSelecionado.registroFotograficoModelado">Registro Fotográfico Modelado</p>	
                  </v-col>
                  <v-col cols="3">
                    <span class="font-weight-bold text-uppercase">Tipologia: </span>
                    <span class="font-weight-light  title">{{ indicadorSelecionado.tipologia }}</span>
                  </v-col>
                  <v-col cols="3">
                    <span class="font-weight-bold text-uppercase">Valor de Base: </span>
                    <span class="font-weight-light title">{{indicadorSelecionado.valorDeBase}}</span>
                  </v-col>
                  <v-col cols="3">
                    <span class="font-weight-bold text-uppercase">Valor Esperado: </span>
                    <span class="font-weight-light   title">{{indicadorSelecionado.totalEsperado}}</span>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-card-actions class="pb-8 mx-2">
                <IndicadorEdita
                  v-if="indicadorSelecionado.id"                
                  titulo="Editar Indicador"
                  :logicaIntervencao="logicaIntervencao"
                  :indicador="indicadorSelecionado"
                ></IndicadorEdita>
                <v-btn @click="excluir" color="error text-center" small class="ml-2">Excluir</v-btn>
                <Confirm ref="confirm"></Confirm>
              </v-card-actions>

          </v-card>
        </v-tab-item>

        <v-tab-item :value="'tab-fontes'">
          <FonteVerificacao v-if="indicadorSelecionado.id" :indicadorSelecionado="indicadorSelecionado"></FonteVerificacao>
        </v-tab-item>
      </v-tabs>
    </v-container>
  </div>
</template>

<script>
import IndicadorAdiciona from "@/pages/Projeto/pages/Indicador/Adiciona/IndicadorAdiciona";
import IndicadorEdita from "@/pages/Projeto/pages/Indicador/Edita/IndicadorEdita";
import FonteVerificacao from "@/pages/Projeto/components/FonteVerificacao/FonteVerificacao";
import Confirm from "@/components/Dialog/Confirm";

import asyncDataStatus from "@/mixins/asyncDataStatus";
import { mapActions } from "vuex";

export default {
  name: "IndicadorManagement",

  components: {
    IndicadorAdiciona,
    IndicadorEdita,
    FonteVerificacao,
    Confirm
  },

  props: {
    logicaIntervencao: {
      require: false,
    },
  },
  mixins: [asyncDataStatus],

  data() {
    return {
      search: "",
      dialog: false,
      headers: [
        {
          text: "Indicador",
          align: "start",
          value: "tituloFormatado",
          width: "40%",
        },
        { text: "Responsável por Lançamento", value: "responsavel.nome", width: "20%" },
        { text: "Tipologia", value: "tipologia" },
        { text: "Valor de Base", value: "valorDeBase" },
        { text: "Total Esperado", value: "totalEsperado" },
        { text: "Valor Atual", value: "totalAtingido" },
        { text: "Total Atingido(%)", value: "totalAtingido" },
      ],
      headersl: [
        { text: "Mês de lançamento", align: "start", value: "mes"},
        { text: "Lançado por", value: "lancadoPor.nome" },
        { text: "Status", value: "status" },
        { text: "Monitorado por", value: "monitoradoPor.nome" },
        { text: "Progresso gdfgd", value: "progresso" },
        { text: "Ações" },
      ],      
      indicadorSelecionado: {}
    };
  },
  computed: {
    indicadores() {
      return this.$store.getters["indicador/byLogicaIntervencaoId"](
        parseInt(this.logicaIntervencao.id)
      );
    },
    lancamentos() {
      return this.$store.getters['lancamento/byIndicadorId'](this.indicadorSelecionado.id)
    },
    routeNameIndicador() {
      return 'Indicador' + this.$store.getters["enums/nivel"][this.logicaIntervencao.nivel].routeName
    },
    usuario() {
      return this.$store.getters["usuario/getUser"]
    },

    isPermissao() {
      //candEdit
      if(this.$store.getters["auth/isAdministrador"]) {
        return true
      }
      
      var payload = {
        'permission': 'PERMISSION_INDICADOR_EDIT',
        'projetoId': parseInt(this.$route.params.projetoId),
        'usuarioId': this.$store.getters["usuario/getUsuarioAutenticado"].id,
      }
      
      return this.$store.getters["projeto/hasPermission"](payload);
    },    
  },
  watch: {
    indicadores() {
      if(this.indicadores.length) {
        if (!this.indicadorSelecionado.id) {
          this.indicadorSelecionado = this.indicadores[0];
        } else {
          this.indicadorSelecionado = this.indicadores.find(indicador => indicador.id === this.indicadorSelecionado.id);
        }
      }
    },  
  },
  methods: {
    ...mapActions("indicador", ["fetchIndicadores"]),

    toPath(indicadorId) {
      const to = this.$route.fullPath + "/indicador/" + indicadorId;
      return to;
    },

    excluir() {
      this.$refs.confirm
        .open(
          "Excluir Indicador",
          this.indicadorSelecionado.posicaoFormatada + " " +this.indicadorSelecionado.titulo,
          "Você tem certeza?",
          {}
        )
        .then((confirm) => {
          if (confirm) {
            this.$store.dispatch("indicador/deleteIndicador", this.indicadorSelecionado.id)
          }
        });
    },

  },
  created() {
    this.fetchIndicadores(this.logicaIntervencao.id).then(() => {
      this.asyncDataStatus_fetched();
    });
  },
};
</script>

<style src="./IndicadorGerenciamento.scss" lang="scss"/>

